import { createContext, useContext, useMemo } from 'react';
import useBannerHelpers, { BannerHelpers } from '../utils/use-banner-helpers';
import { EnhancedCampaign } from '~/components/casino-shared/types';

export interface BannerContextProviderProps {
	children: React.ReactNode;
	data: EnhancedCampaign;
	index: number;
}

interface BannerContextValue {
	data: EnhancedCampaign;
	helpers: BannerHelpers;
}

const BannerContext = createContext({} as BannerContextValue);

export const useBannerContext = () => useContext(BannerContext);

export const BannerContextProvider: React.FC<BannerContextProviderProps> = ({ children, data, index }) => {
	const helpers = useBannerHelpers(data, index);

	const value = useMemo(
		() => ({
			data,
			helpers
		}),
		[data, helpers]
	);

	return <BannerContext.Provider value={value}>{children}</BannerContext.Provider>;
};
